<mat-tab-group
  color="accent"
  [(selectedIndex)]="selectedIndex"
  (selectedIndexChange)="onTabChanged($event)"
  animationDuration="0"
>
  @for (tab of viewTabs; track tab) {
    <mat-tab [label]="tab.description.label">
      <ng-template mat-tab-label>
        <span>{{ tab.description.label }}</span>
        <div class="tab-badge" [style.backgroundColor]="tab.description.color">
          @if (!tab.isLoading) {
            @if (tab.count$ | async; as tabCount) {
              {{ getTabCountString(tabCount) }}
            } @else {
              0
            }
          } @else {
            &hellip;
          }
        </div>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
